module.exports = __webpack_public_path__ + "static/images/tp_glht1_click.202506261133.png";